import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator, displayBrandSliderOnLoad} from './components/sliders.js';
import { showMoreFaqs, accordion } from './components/accordion.js';
import { handleDemoFormOrBot } from './components/get-a-demo.js';

document.addEventListener("DOMContentLoaded", function () {
  slickSliderGenerator('brand', '.logos-container');
  slickSliderGenerator('features', '.features-container');
  slickSliderGenerator('workflow_normal', '.workflow-normal-container');
  handleDemoFormOrBot();
  displayBrandSliderOnLoad();
  accordion('.faqs-cards');
  showMoreFaqs();
  getSVG();
});
